import { createSlice } from '@reduxjs/toolkit'

export const searchResultSlice = createSlice({
  name: 'searchResult',
  initialState: {
    value: null,
  },
  reducers: {
    resetSearchResultPayload: (state) => {
        state.value = null
    },
    setSearchResultPayload : (state, action) => {
      state.value = action.payload
    }
  },
})

export const { resetSearchResultPayload, setSearchResultPayload } = searchResultSlice.actions
export default searchResultSlice.reducer